import styled from 'styled-components'

export const ToastContainer = styled.div`
  position: fixed;
  right: var(--size-medium);
  z-index: 2;
  width: calc(100% - 2 * var(--size-medium));
`
